import { defineMessages, useIntl } from 'react-intl';
import { SiteProperty } from 'volto-site-settings';
import LogoImage from '@plone/volto/components/theme/Logo/Logo.svg';

import { BrandWrapper } from '@redturtle/volto-io-studio/components/Layout';

const BrandFooter = () => {
  const intl = useIntl();

  const messages = defineMessages({
    logo: {
      id: 'Logo',
      defaultMessage: 'Logo',
    },
  });

  return (
    <BrandWrapper className="brand-footer" showBrandText={false}>
      <SiteProperty
        property="site_logo_footer"
        defaultValue={{ url: LogoImage, height: 58, width: 255 }}
        className="icon"
        alt={intl.formatMessage(messages.logo)}
      />
    </BrandWrapper>
  );
};

export default BrandFooter;
